<template>
	<div class="layout">
		<div class="myFloatBox">
			<div class="fItem" @click="$router.push({ name: 'allequpt', query: { routeName: 'wtsj' } })">
				<img src="@/assets/img/wtsj.png" alt="" />
				<p>委托送检</p>
			</div>
			<div class="fItem" @click="$router.push({ name: 'userguide' })">
				<img src="@/assets/img/yhzn.png" alt="" />
				<p>用户指南</p>
			</div>
		</div>
		<survey ref="survey" v-if="surveyVisible"></survey>
		<layout-header></layout-header>
		<div style="height:152px"></div>
		<layout-content></layout-content>
		<layout-footer></layout-footer>
	</div>
</template>

<script>
import Survey from '../common/survey.vue'
import LayoutHeader from './Layout-header.vue'
import LayoutContent from './Layout-content.vue'
import LayoutFooter from './Layout-footer.vue'
export default {
	components: {
		Survey,
		LayoutHeader,
		LayoutContent,
		LayoutFooter,
	},

	data() {
		return {}
	},
	computed: {
		surveyVisible: {
			get() {
				return this.$store.state.surveyVisible
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.layout {
	// display: flex;
	flex-direction: column;
	height: 100vh;
	min-width: max-content;
}
.myFloatBox {
	position: fixed;
	right: 16px;
	top: 45%;
	z-index: 999;
	.fItem {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 68px;
		height: 68px;
		background: #ffffff;
		box-shadow: 0px 2px 31px 1px rgba(0, 15, 30, 0.16);
		border-radius: 8px 8px 8px 8px;
		margin-bottom: 8px;
		cursor: pointer;
		user-select: none;
		&:hover {
			opacity: 0.8;
		}
		img {
			width: 25px;
			height: 25px;
			margin-bottom: 4px;
		}
		p {
			font-size: 12px;
			margin: 0;
		}
	}
}
</style>
